import type { Locale } from "./locales";

/** Per-locale text; `en` is required and is the fallback. */
export type I18nText = { en: string } & Partial<Record<Locale, string>>;

export function pickText(t: I18nText, locale: Locale): string {
  return t[locale] ?? t.en;
}

export type Artist = {
  slug: string;
  name: string;
  years: string;
  nationality: I18nText;
  bio: I18nText;
};

export type Artwork = {
  slug: string;
  artistSlug: string;
  artistName: string;
  title: I18nText;
  year: string;
  description: I18nText;
  imageUrl: string;
  /** Width / height of the original, so the order form can suggest matching canvas sizes. */
  aspect: number;
};

export type OrderKind = "reproduction" | "custom";

export type OrderStatus =
  | "awaiting_payment" // order created, checkout not finished
  | "paid"             // payment confirmed
  | "sketching"        // artist preparing composition (custom orders: proof sent to customer)
  | "painting"
  | "drying"           // oil paint needs 1-2 weeks before it can be rolled/framed
  | "shipped"
  | "delivered"
  | "cancelled";

export const ORDER_STATUS_FLOW: OrderStatus[] = [
  "awaiting_payment", "paid", "sketching", "painting", "drying", "shipped", "delivered",
];
